const initialState = {
  dealSavedFromModal: false,
  savingDeal: false
};

const dealsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DEAL_SAVED_FROM_MODAL_STATUS':
      return {
        ...state,
        dealSavedFromModal: action.data.status,
        savingDeal: action.data.savingDeal
      };
    default:
      return state;
  }
};

export default dealsReducer;
